import { render, staticRenderFns } from "./btn-primary-disabled.mpx?vue&type=template&id=167936d7&isComponent&outputPath=components%2Fbtn-primary-disabled61149940%2Findex"
import script from "./btn-primary-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-primary-disabled61149940%2Findex"
export * from "./btn-primary-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-primary-disabled61149940%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports